<template>
  <div>
    <section>
      <!-- <select
        v-if="payouts"
        v-model="selectedPayout"
        :disabled="isLoadingReport"
        @change="load(checkReport(selectedPayout))"
      >
        <option :value="null" selected>Choose a payout</option>
        <option v-for="payout in payouts" :key="payout.id" :value="payout">
          {{ new Date(payout.periodStart).toLocaleDateString("sv-SE") }} -
          {{ new Date(payout.periodEnd).toLocaleDateString("sv-SE") }}</option
        >
      </select> -->
      <FileUploader v-if="payouts" @content="load($event)"
        >Upload bank file</FileUploader
      >

      <span
        v-if="isLoadingReport || !payouts || (status && status != 'succeeded')"
        class="spinner is-centered select-loader"
      ></span>
      <p v-if="status && status != 'succeeded'">
        Tax report status: {{ status }}
      </p>

      <p v-if="errorMessage">{{ errorMessage }}</p>
    </section>

    <section v-if="documentValues">
      <h2 class="title is-2">Bank</h2>
      <table class="table is-striped">
        <tbody>
          <tr>
            <td>Month</td>
            <td>{{ documentValues.month }}</td>
          </tr>

          <tr>
            <td>Period</td>
            <td>
              {{
                new Date(selectedPayout.periodStart).toLocaleDateString("sv-SE")
              }}
              -
              {{
                new Date(selectedPayout.periodEnd).toLocaleDateString("sv-SE")
              }}
            </td>
          </tr>

          <tr>
            <td>Exchange rate</td>
            <td>
              {{ sek(documentValues.exchangeRate) }} ({{
                documentValues.exchangeRate
              }})
            </td>
          </tr>

          <tr>
            <td>EUR</td>
            <td>
              {{ eur(documentValues.eur) }}
            </td>
          </tr>

          <tr>
            <td>SEK</td>

            <td>
              {{ sek(documentValues.sek) }}
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <section v-if="report">
      <h2 class="title is-2">Stripe</h2>
      <table class="table is-striped">
        <thead>
          <tr>
            <th>Country</th>
            <th>Before tax</th>
            <th>Tax</th>
            <th>
              Total
            </th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>Sweden</td>
            <td>{{ sek(report.totals.sweden.beforeTax) }}</td>
            <td>{{ sek(report.totals.sweden.tax) }}</td>
            <td>{{ sek(report.totals.sweden.total) }}</td>
          </tr>

          <tr>
            <td>Company EU</td>
            <td>{{ sek(report.totals.companyEu.beforeTax) }}</td>
            <td>{{ sek(report.totals.companyEu.tax) }}</td>
            <td>{{ sek(report.totals.companyEu.total) }} (3308)</td>
          </tr>

          <tr>
            <td>Private EU</td>
            <td>{{ sek(report.totals.privateEu.beforeTax) }} (3106)</td>
            <td>{{ sek(report.totals.privateEu.tax) }} (2611)</td>
            <td>{{ sek(report.totals.privateEu.total) }}</td>
          </tr>

          <tr>
            <td>Outside EU</td>
            <td></td>
            <td></td>
            <td>{{ sek(report.totals.outsideEu.total) }} (3305)</td>
          </tr>

          <tr>
            <td>Total</td>
            <td>{{ sek(report.totals.all.beforeTax) }}</td>
            <td>{{ sek(report.totals.all.tax) }}</td>
            <td>{{ sek(report.totals.all.total) }}</td>
          </tr>

          <tr>
            <td>Fee</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>{{ sek(-report.totals.fee) }} (6570)</td>
          </tr>

          <tr
            class="has-text-white"
            :class="{
              'has-background-primary':
                report.totals.all.total - report.totals.fee ===
                documentValues.sek,

              'has-background-warning':
                report.totals.all.total - report.totals.fee !==
                documentValues.sek,
            }"
          >
            <td>Sum</td>
            <td></td>
            <td></td>
            <td>
              {{ sek(report.totals.all.total - report.totals.fee) }}
              <span
                v-if="
                  report.totals.all.total - report.totals.fee !==
                    documentValues.sek
                "
                >(diff:
                {{
                  sek(
                    report.totals.all.total -
                      report.totals.fee -
                      documentValues.sek
                  )
                }}) (3740)
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="table is-striped">
        <thead>
          <tr>
            <th>E-mail</th>
            <th>Country</th>
            <th>VAT number</th>
            <th>Moms type</th>
            <th>Before tax</th>
            <th>Tax</th>
            <th>Total</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="company of report.companiesTax"
            :key="company.customer + company.type"
          >
            <td>{{ company.email }}</td>
            <td>{{ company.country }}</td>
            <td>
              <span
                v-if="company.type == 'companyEu' || company.type == 'sweden'"
                >{{ company.vat ? company.vat : "No VAT" }}</span
              >
              <span v-else>N/A</span>
            </td>
            <td>
              <span v-if="company.type == 'sweden'">Swedish moms</span>
              <span v-else-if="company.type == 'companyEu'"
                >Company EU: Reversed moms</span
              >
              <span v-else-if="company.type == 'privateEu'"
                >Private EU: Moms</span
              >
              <span v-else-if="company.type == 'outsideEu'"
                >Outside EU: No moms</span
              >
            </td>

            <td>
              {{ company.type == "outsideEu" ? "N/A" : sek(company.beforeTax) }}
            </td>
            <td>
              {{ company.type == "outsideEu" ? "N/A" : sek(company.tax) }}
            </td>
            <td>{{ sek(company.total) }}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
import FileUploader from "@/components/singles/FileUploader.vue";

export default {
  components: { FileUploader },

  data() {
    return {
      payouts: null,
      selectedPayout: null,
      isLoadingReport: false,

      report: null,
      isLoadingDocument: false,
      documentValues: null,
      errorMessage: "",
      status: null,
    };
  },

  created() {
    this.getPayouts();
  },

  methods: {
    load(content) {
      this.report = null;
      this.documentValues = this.documentValues;
      this.errorMessage = "";

      const lines = content.split("\n");
      const values = this.getDocumentValues(lines[1]);
      this.documentValues = values;

      const payout = this.payouts.find(
        (x) =>
          x.month == values.month &&
          values.date.getFullYear() == new Date(x.created).getFullYear()
      );
      if (!payout) {
        this.errorMessage =
          "Could not find a payout for this period " +
          values.date.toLocaleString("sv-SE");
        return;
      }
      this.selectedPayout = payout;
      this.checkReport(this.selectedPayout);
    },

    getDocumentFloat(value) {
      return parseFloat(value.replace(",", "."));
    },

    getDocumentValues(line) {
      const values = line
        .toLowerCase()
        .replace(/"/g, "")
        .split(";")
        .map((x) => x.trim());

      const date = new Date(values[0]);
      return {
        date: date,
        month: date.getMonth() + 1,
        eur: this.getDocumentFloat(values[9]),
        sek: this.getDocumentFloat(values[5]),
        exchangeRate: this.getDocumentFloat(values[10]),
      };
    },

    sek(amount) {
      return new Intl.NumberFormat("sv-SE", {
        style: "currency",
        currency: "SEK",
      }).format(amount);
    },

    eur(amount) {
      return new Intl.NumberFormat("sv-SE", {
        style: "currency",
        currency: "EUR",
      }).format(amount);
    },

    async getPayouts() {
      const data = await this.$helpers.PostApi("get/payouts");
      this.payouts = data;
    },

    async getReport(selectedPayout, exchangeRate, eur) {
      try {
        this.isLoadingReport = true;
        const data = await this.$helpers.PostApi("get/tax-report", {
          payout: selectedPayout,
          exchangeRate,
          sum: eur,
        });

        this.report = data;

        this.$helpers.ShowStatus(
          "The report is loaded <span style='margin-left:10px;' class='icon'><i class='fas fa-lg fa-grin-beam'></i></span>",
          4000
        );
      } catch (error) {
        this.errorMessage = error.message;
      }

      this.isLoadingReport = false;
    },

    async checkReport(selectedPayout) {
      this.status = "pending";

      this.$helpers.ShowStatus("Checking report", 4000);
      let reportId;

      while (this.status != "succeeded") {
        await new Promise((resolve) => setTimeout(resolve, 4000));
        const data = await this.$helpers.PostApi("get/check-report", {
          payout: selectedPayout,
          reportId,
        });

        this.status = data.status;
        reportId = data.id;
      }

      if (this.status == "succeeded") {
        this.getReport(
          selectedPayout,
          this.documentValues.exchangeRate,
          this.documentValues.eur
        );
      }
    },
  },
};
</script>

<style scoped>
.select-loader {
  margin-left: 20px;
}
</style>
